import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import styles from "./ListLocation.module.css";
import { DownIcon, LeftIcon } from "../../../components/Icons/Icons";
import WareHouse from "./WareHouse";
import { Loading } from "../../../components";
import { sorterArray } from "../../../utils";
const cx = classNames.bind(styles);
const ListLocation = ({ name, indexLocation, icon, show, onClick, value, code, isGroup, filter, wareHouses }) => {
  const [warehouse, setWarehouse] = useState([])
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)
  const [groupCode, setGroupCode] = useState(null)
  const [statusCode, setStatusCode] = useState(null)
  const [recordCode, setRecordCode] = useState(null)
  useEffect(() => {
    if (isGroup) {
      setGroupCode(code)
    } else {
      setGroupCode(null)
    }
    // eslint-disable-next-line
  }, [code])
  useEffect(() => {
    if (filter && filter.length > 0) {
      filter.forEach((item) => {
        switch (item.type) {
          case 'group':
            if (item.code) {
              setGroupCode(item.code);
            }
            break;
          case 'status':
            setStatusCode(item.code)
            break;
          case 'record':
            setRecordCode(item.code)
            break;
          default:
            return 0
        }
      })
    } else if (isGroup) {
      setGroupCode(code)
    } else {
      // setProvinceCode(code)
    }
    // eslint-disable-next-line
  }, [filter, isGroup, code])


  const onClicks = (e, index) => {
    onClick(index);
  };
  const handleShowCam = (value) => {
    const data = warehouse.map((item, index) => {
      if (index === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      } else {
        return {
          ...item,
          isShow: false,
          icon: <LeftIcon />,
        };
      }

    });
    setWarehouse(data);
  };
  useEffect(() => {
    if (wareHouses) {
      const data = wareHouses.map((item) => {
        return {
          code: item.WAREHOUSE_CODE,
          name: item.WAREHOUSE_NAME,
          longitude: item.LONGITUDE,
          latitude: item.LATITUDE,
          isShow: false,
          icon: <LeftIcon />,
          isCheck: false,
        };
      });
      if (data) {
        const wareHouseSort = sorterArray(data, 'name')
        setWarehouse(wareHouseSort);
      }
    }
  }, [wareHouses]);
  return (
    <div className={cx("item")}>
      <div onClick={(e) => onClicks(e, indexLocation)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {show && (
        <>
          {loading ? <Loading /> : (
            <div className={cx("warehouse")}>
              {warehouse &&
                warehouse.map((item, index) => (
                  <WareHouse
                    data={item}
                    indexWareHouse={index}
                    onClick={handleShowCam}
                    parentShow={show}
                    key={index}
                    show={item.isShow}
                    icon={item.icon}
                    name={item.name}
                    setWarehouse={setWarehouse}
                    code={item.code}
                    value={value}
                    status={statusCode}
                    record={recordCode}
                    groupCode={groupCode}
                  />
                ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
ListLocation.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  wareHouses: PropTypes.array,
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ListLocation;
